import { usePageTitle } from './hooks/usePageTitle';

function ClientCenter() {
  usePageTitle('Client Center')

  return (
    <div
      id="ts-contact-us-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-about-us-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2">
          Client Center
        </div>

        <div className="w-full text-center text-normal text-light-text p-2 border-b border-light-border">
          Some items in this category are only available to registered
          TerraStation Users.
        </div>

        <div
          className="w-full flex flex-col items-center justify-center mt-4 p-4 border-b border-light-border"
          id="ts-client-center-group-newsletter "
        >
          <div className="w-full text-center text-normal text-light-text">
            View all of TerraSciences' Newsletters
          </div>
          <a
            href="/client-center/newsletters"
            className="w-1/2 mt-2 p-4 flex bg-light-main hover:bg-light-main-hover duration-200 items-center justify-center text-light-text-alt rounded-sm cursor-pointer"
          >
            Newsletters
          </a>
        </div>
        <div
          className="w-full flex flex-col items-center justify-center mt-4 p-4 border-b border-light-border"
          id="ts-client-center-group-usefulreading"
        >
          <div className="w-full text-center text-normal text-light-text">
            See the recommended Reading List.
          </div>
          <a
            href="/client-center/useful-reading"
            className="w-1/2 mt-2 p-4 flex bg-light-main hover:bg-light-main-hover duration-200 items-center justify-center text-light-text-alt rounded-sm cursor-pointer"
          >
            Useful Reading
          </a>
        </div>
        <div
          className="w-full flex flex-col items-center justify-center mt-4 p-4 border-b border-light-border"
          id="ts-client-center-group-relatedarticles"
        >
          <div className="w-full text-center text-normal text-light-text">
            Read more articles on TerraScience's related content.
          </div>
          <a
            href="/client-center/related-articles"
            className="w-1/2 mt-2 p-4 flex bg-light-main hover:bg-light-main-hover duration-200 items-center justify-center text-light-text-alt rounded-sm cursor-pointer"
          >
            Related Articles
          </a>
        </div>
        <div
          className="w-full flex flex-col items-center justify-center mt-4 p-4 border-b border-light-border"
          id="ts-client-center-group-links"
        >
          <div className="w-full text-center text-normal text-light-text">
            External Resources
          </div>
          <a
            href="/client-center/links"
            className="w-1/2 mt-2 p-4 flex bg-light-main hover:bg-light-main-hover duration-200 items-center justify-center text-light-text-alt rounded-sm cursor-pointer"
          >
            Links
          </a>
        </div>
      </div>
    </div>
  );
}

export default ClientCenter;
